export const LANGS = ['en', 'kr', 'jp'];
export const BASE_SERVER_PORT = 9080;
export const NESS_STORE_DOMAIN_NAME = 'collection';
export const NESS_FREE_SHIP_CODE = 'FREESHIPPING-80';
export const NESS_FREE_SHIP_ID = 12999;

export const NESS_FREE_SHIPPING_INFO_PRODUCT = `80,000원 이상 구매 시 기본 배송비 무료!`;
export const NESS_FREE_SHIPPING_INFO_CART = `총 상품 금액 8만원 이상 시, 기본 배송비는 결제 단계에서 자동 차감됩니다.`;
export const NESS_FREE_SHIPPING_INFO_CHECKOUT = `8만원 이상 구매 시 기본 배송비 무료`;
